// There's already a node module named colors :(

let colors =
{
	SKILL1: "#FF6914",
	SKILL2: "#C9FB13",
	SKILL3: "#11DBA3",
	SKILL4: "#E4144A",
};

module.exports = colors;


// WEBPACK FOOTER //
// ./src/js/colours.js